import { render } from "./report-template-removal-modal.vue?vue&type=template&id=923e379e"
import script from "./report-template-removal-modal.vue?vue&type=script&lang=js"
export * from "./report-template-removal-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__